import {
  type DependencyList,
  type EffectCallback,
  useEffect,
  useRef,
} from 'react';

/**
 * Like useEffect, but skips the first invocation (mount).
 * Useful for callbacks that should only fire on subsequent updates.
 */
export function useNextEffect(effect: EffectCallback, deps: DependencyList) {
  const mounted = useRef(false);

  useEffect(() => {
    if (!mounted.current) {
      mounted.current = true;
      return;
    }
    return effect();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
}
